import {
  bulkInvite as publicBulkInvite,
  resendInvite as publicResendInvite,
  revokeInvite as publicRevokeInvite,
} from './identity-invites-v1-site-invite-site-invites.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const bulkInvite: MaybeContext<
  BuildRESTFunction<typeof publicBulkInvite> & typeof publicBulkInvite
> = /*#__PURE__*/ createRESTModule(publicBulkInvite);
export const resendInvite: MaybeContext<
  BuildRESTFunction<typeof publicResendInvite> & typeof publicResendInvite
> = /*#__PURE__*/ createRESTModule(publicResendInvite);
export const revokeInvite: MaybeContext<
  BuildRESTFunction<typeof publicRevokeInvite> & typeof publicRevokeInvite
> = /*#__PURE__*/ createRESTModule(publicRevokeInvite);

export {
  InviteStatus,
  SortOrder,
} from './identity-invites-v1-site-invite-site-invites.universal.js';
export {
  SiteInvite,
  GetSiteInvitesRequest,
  GetSiteInvitesResponse,
  QuerySiteInvitesRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QuerySiteInvitesResponse,
  GetSiteInviteRequest,
  GetSiteInviteResponse,
  SiteInviteRequest,
  LocationRestriction,
  SiteInviteResponse,
  BulkSiteInviteRequest,
  BulkSiteInviteResponse,
  ResendSiteInviteRequest,
  AcceptSiteInviteRequest,
  AcceptSiteInviteResponse,
  RevokeSiteInviteRequest,
  RevokeSiteInviteResponse,
  UpdateSiteInviteRequest,
  UpdateSiteInviteResponse,
  GetContributorLimitRequest,
  GetContributorLimitResponse,
  ContributorLimitation,
  ParseSiteInviteTokenRequest,
  ParseSiteInviteTokenResponse,
  BulkInviteOptions,
  ResendInviteOptions,
} from './identity-invites-v1-site-invite-site-invites.universal.js';
export {
  InviteStatusWithLiterals,
  SortOrderWithLiterals,
} from './identity-invites-v1-site-invite-site-invites.universal.js';
